import { Modal } from "antd";
import GetPhoneNumber from "./getPhonenumberModal";
import VerificationModal from "./verificationModal";
import GetUserInfoModal from "./getUserInfo";
import { useState } from "react";
import { FiArrowDownLeft, FiArrowLeft, FiX } from "react-icons/fi";

const RegisterComponent = (props) => {
  const [step, setStep] = useState(0);
  const [userInfo, setUserInfo] = useState({
    mobileNo: '',
    firstName: '',
    lastName: '',
    nationalCode: '',
    referralNo: '',
    genderId: null
  });

  const handleOk = () => {
    props.setOpen(false);
  };
  const handleCancel = () => {
    props.setOpen(false);
    if (props.closeFunction)
      props.closeFunction()
  };

  return (
    <Modal
      open={props.open}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      width={420}
    >

      {step === 0 && (
        <GetPhoneNumber
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          setStep={setStep}
        />
      )}

      {step === 1 && (
        <GetUserInfoModal userInfo={userInfo}
          setUserInfo={setUserInfo} setStep={setStep} />
      )}

      {step === 2 && (
        <VerificationModal userInfo={userInfo}
          setUserInfo={setUserInfo} setStep={setStep}
          ReserveFunc={props.ReserveFunc}
          hasReserve={props.hasReserve}
        />
      )}


    </Modal>
  );
};

export default RegisterComponent;
